module.exports = __webpack_public_path__ + "img/1536485730.5b6d651d.jpg";